const sortCourses = function(arr) {
    if(arr === undefined) {
        return [];
    }
    return (JSON.parse(JSON.stringify(arr))).sort(sortAlphaNum);
};

function sortAlphaNum(fullA, fullB) {
    let a = fullA.course_code;
    let b = fullB.course_code;
    let reA = /[^a-zA-Z]/g;
    let reN = /[^0-9]/g;
    let aA = "";
    let bA = "";
    let aStart = 0;
    let bStart = 0;
    for(let i = 0; i < a.length; i++) {
        if('0' <= a.charAt(i) && a.charAt(i) <= '9') {
            aA = a.substring(0, i);
            aStart = i;
            break;
        }
    }
    for(let i = 0; i < b.length; i++) {
        if('0' <= b.charAt(i) && b.charAt(i) <= '9') {
            bA = b.substring(0, i);
            bStart = i;
            break;
        }
    }
    if (aA === bA) {
        let aN = 0;
        let bN = 0;
        let aaStart = 0;
        let bbStart = 0;
        for(let i = aStart; i < a.length; i++) {
            if('A' <= a.charAt(i) && a.charAt(i) <= 'Z') {
                aN = parseInt(a.substring(aStart, i));
                aaStart = i;
                break;
            }
        }
        for(let i = bStart; i < b.length; i++) {
            if('A' <= b.charAt(i) && b.charAt(i) <= 'Z') {
                bN = parseInt(b.substring(bStart, i));
                bbStart = i;
                break;
            }
        }
        if(aaStart === 0) {
            aN = parseInt(a.substring(aStart));
        }
        if(bbStart === 0) {
            bN = parseInt(b.substring(bStart));
        }
        if(aN === bN) {
            let a2A = "";
            let b2A = "";
            if(aaStart !== 0) {
                a2A = a.substring(aaStart);
            }
            if(bbStart !== 0) {
                b2A = b.substring(bbStart);
            }
            return a2A === b2A ? 0 : (a2A > b2A ? 1 : -1);
        } else {
            return aN > bN ? 1 : -1;
        }
    } else {
        return aA > bA ? 1 : -1;
    }
}

export default sortCourses;